import React, { ChangeEvent } from 'react'
import { Box, Button, CircularProgress, DialogActions } from '@mui/material'
import { csvUploadText } from './CSVUpload.config'
import type { CSVTableHeader } from './CSVUpload.types'

interface CSVUploadDialogActionsProps {
  disabledState: boolean
  uploadDisabledState: boolean
  isLoadingColumns: boolean
  isUploading: boolean
  inputId: string
  tableHeaders: CSVTableHeader[]
  onFileChange: (event: ChangeEvent<HTMLInputElement>) => void
  onDownloadTemplate: () => void
  onClose: () => void
}

/**
 * Footer actions for upload, template download, and dialog close.
 * @param props - Action handlers and disabled/loading state
 * @returns CSV upload dialog action area
 */
export function CSVUploadDialogActions({
  disabledState,
  uploadDisabledState,
  isLoadingColumns,
  isUploading,
  inputId,
  tableHeaders,
  onFileChange,
  onDownloadTemplate,
  onClose,
}: CSVUploadDialogActionsProps) {
  return (
    <DialogActions>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Box sx={{ justifySelf: 'start' }}>
          <Button
            variant="contained"
            component="label"
            disabled={uploadDisabledState}
            data-testid="csv-task-upload-button"
          >
            {isLoadingColumns || isUploading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              csvUploadText.uploadButtonLabel
            )}
            <input
              hidden
              id={inputId}
              type="file"
              accept=".csv,text/csv"
              onChange={onFileChange}
              disabled={uploadDisabledState}
              data-testid="csv-task-upload-input"
            />
          </Button>
        </Box>
        <Box sx={{ justifySelf: 'center' }}>
          <Button
            onClick={onDownloadTemplate}
            disabled={disabledState || tableHeaders.length === 0}
            data-testid="csv-task-download-template-button"
          >
            {csvUploadText.downloadTemplateButtonLabel}
          </Button>
        </Box>
        <Box sx={{ justifySelf: 'end' }}>
          <Button onClick={onClose} data-testid="csv-task-cancel-button">
            {csvUploadText.cancelButtonLabel}
          </Button>
        </Box>
      </Box>
    </DialogActions>
  )
}
